import { Flex, Menu, Text } from "@mantine/core";
import type { TablerIcon } from "@tabler/icons-react";

export function MenuButton({
  id,
  parentId,
  label,
  icon,
  onClick,
  disabled = false,
}: {
  id: string;
  parentId?: string;
  label: string;
  icon: TablerIcon;
  onClick: (actionId: string, parentId?: string) => void;
  disabled?: boolean;
}) {
  const menuItemColor = disabled
    ? "var(--mantine-color-gray-6)"
    : "var(--mantine-color-dark-6)";

  const Icon = icon;

  function onClickHandler() {
    if (disabled) return;
    onClick(id, parentId);
  }

  return (
    <Menu.Item
      onClick={onClickHandler}
      disabled={disabled}
      opacity={disabled ? 0.6 : 1}
      color="var(--mantine-color-gray-2)"
      c={menuItemColor}
    >
      <Flex
        w="100%"
        direction="row"
        align="center"
        justify="flex-start"
        gap="xs"
      >
        <Icon stroke={1.2} size={22} color="var(--mantine-color-dark-6)" />
        <Text flex={1} fw={400} fz={15} c="var(--mantine-color-dark-6)">
          {label}
        </Text>
      </Flex>
    </Menu.Item>
  );
}
